// Shimmer-free skeleton block: token-driven pulse on the muted surface.
const SK = 'animate-pulse rounded bg-muted';

const ComparePickCardSkeleton = ({
  showCompareButton = true,
}: {
  showCompareButton?: boolean;
}) => (
  <article
    className="relative mt-[18px] flex flex-col gap-2 rounded-xl border border-solid border-[color:rgba(255,255,255,0.08)] bg-[color:rgba(255,255,255,0.025)] px-3.5 pb-3 pt-3.5 shadow-[inset_0_1px_0_rgba(255,255,255,0.02)]"
    aria-busy="true"
    aria-label="Loading portfolio"
  >
    {showCompareButton && (
      <div className={`${SK} absolute right-3.5 top-0 h-7 w-[88px] -translate-y-1/2 rounded-full`} aria-hidden />
    )}
    <div className="flex min-h-6 items-center gap-2">
      <div className={`${SK} h-4 max-w-[72%] flex-1`} />
      <div className={`${SK} h-[18px] w-12 flex-none rounded-full`} />
    </div>
    <div className={`${SK} h-7 w-[58%]`} />
    <div className={`${SK} h-3.5 w-[42%]`} />
    <dl className="mt-1 grid grid-cols-2 gap-x-2.5 gap-y-1.5 border-t border-[color:rgba(255,255,255,0.06)] pt-2 [&_dt]:text-[0.68rem] [&_dt]:uppercase [&_dt]:tracking-[0.05em] [&_dt]:text-muted-foreground">
      <div className="min-w-0">
        <dt>Started</dt>
        <dd>
          <div className={`${SK} mt-0.5 h-3 w-[68%]`} />
        </dd>
      </div>
      <div className="min-w-0">
        <dt>Last rebalanced</dt>
        <dd>
          <div className={`${SK} mt-0.5 h-3 w-[68%]`} />
        </dd>
      </div>
      <div className="col-span-2 min-w-0">
        <dt>Invested</dt>
        <dd>
          <div className={`${SK} mt-0.5 h-3 w-[42%]`} />
        </dd>
      </div>
    </dl>
  </article>
);

export default ComparePickCardSkeleton;
